// extracted by mini-css-extract-plugin
export default {"root":"HeroImage-module-root","image":"HeroImage-module-image"};